import React from 'react';
import { Divider } from 'antd';

import { Colors } from '~library/prerenderTheme';
import { numberFormatter } from '~library/numbers';
import { MainChartLegend } from '~components/Charts';
import { percentageFormatter, ColorsList } from '../Chart';
import { crawlerCategoryLabel } from '~features/crawler-filter';
import TOOLTIPS from './tooltips';
import { type ChartItemsVisibilityProps } from '~library/chartjs';

type PagesCrawledMainChartLegendProps = {
  totalUncachedPercentage: number;
  totalRequestPerCrawler: [string, number][];
} & ChartItemsVisibilityProps;

function PagesCrawledMainChartLegend({
  totalUncachedPercentage,
  totalRequestPerCrawler,
  itemsVisibility,
  onItemClicked,
}: PagesCrawledMainChartLegendProps) {
  return (
    <MainChartLegend>
      {totalRequestPerCrawler.map(([crawler, amount], i) => (
        <React.Fragment key={crawler}>
          {i === 0 ? (
            <MainChartLegend.LabelBig
              label={crawlerCategoryLabel(crawler)}
              labelColor={ColorsList[i]}
              value={numberFormatter.format(amount)}
              tooltipContent={TOOLTIPS[crawler]}
              onClick={() => onItemClicked(i)}
              crossedOut={!itemsVisibility[i]}
            />
          ) : (
            <MainChartLegend.Label
              label={crawlerCategoryLabel(crawler)}
              labelColor={ColorsList[i]}
              value={numberFormatter.format(amount)}
              tooltipContent={TOOLTIPS[crawler]}
              onClick={() => onItemClicked(i)}
              crossedOut={!itemsVisibility[i]}
            />
          )}
        </React.Fragment>
      ))}

      <Divider type="vertical" style={{ height: 72 }} />
      <MainChartLegend.Label
        label="Cache Misses"
        labelColor={Colors.Orange}
        value={percentageFormatter(totalUncachedPercentage)}
        tooltipContent={TOOLTIPS.uncached}
        onClick={() => onItemClicked(totalRequestPerCrawler.length)}
        crossedOut={!itemsVisibility[totalRequestPerCrawler.length]}
      />
    </MainChartLegend>
  );
}

export default PagesCrawledMainChartLegend;
